import { useAppKit, useAppKitAccount, useAppKitProvider } from '@reown/appkit/react'
import type { Provider as SolanaProvider } from '@reown/appkit-adapter-solana/react'

export function useRoseWallet() {
  const appKit = useAppKit()
  const solana = useAppKitAccount({ namespace: 'solana' })
  const evm = useAppKitAccount({ namespace: 'eip155' })
  const { walletProvider: solanaProvider } = useAppKitProvider<SolanaProvider>('solana')
  const { walletProvider: evmProvider } = useAppKitProvider<any>('eip155')

  return {
    open: appKit.open,
    solana,
    evm,
    solanaProvider,
    evmProvider,
    connected: Boolean(solana.address || evm.address)
  }
}
